<span>{{ 'aichat.feedback.title' | translate }}</span>
<p-chip-radio-group [list]="translatedReasons" [(ngModel)]="selectedReason"></p-chip-radio-group>

<div class="feedback-text-section" *ngIf="selectedReason">
    <span>{{ 'aichat.feedback.thanks' | translate }}</span>
    <div class="feedback-text">
        <p-field-text
            [placeholder]="'aichat.feedback.text_placeholder' | translate"
            (keydown.enter)="$event.preventDefault()"
            [autoFocus]="true"
            [isMultiline]="true"
            [size]="inputSize"
            [autoSizeMinRows]="4"
            [autoSizeMaxRows]="4"
            [(ngModel)]="feedbackText"
        ></p-field-text>
        <p-action-button class="submit-feedback-text" [label]="'aichat.general.submit' | translate" (buttonClicked)="submitButtonClicked()">
        </p-action-button>
    </div>
</div>
